import { render } from "./ModalInformation.vue?vue&type=template&id=1927e9db"
import script from "./ModalInformation.vue?vue&type=script&lang=js"
export * from "./ModalInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__